import React from 'react'
import { Mensajes } from '../../../types/chat/conversaciones/Conversaciones'
import {
  CheckOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { InView } from "react-intersection-observer";
import { socket } from '../../../utils/services/socket';
import { formatTimeZone } from '../../../utils/formatTime/FormatTimeZone';

interface ChatBubbleProps {
  messages: Mensajes[];
  userId: number;
  messageSelf: boolean;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({ messages, userId, messageSelf }) => {

  const dateGroup = messages[0]['createdAt']
  const readGroup = messages[0]['leido']

  return (
    <div className='flex items-end gap-1'>
      <div
        className={`max-w-xs md:max-w-md px-3 pt-2 pb-1 rounded-t-lg 
          ${messageSelf 
            ? 'bg-blue-500 text-white rounded-bl-lg' 
            : 'bg-gray-100 rounded-t-lg rounded-br-lg'}`
          }
      >
        {[...messages].reverse().map((message: Mensajes, index: number) => (
          <InView
            key={message.id}
            threshold={1}
            as="div"
            className={`flex items-end ${messageSelf ? 'justify-end' : ''} leading-normal`}
            onChange={(inView, entry) => {
              if (inView && message.emisorId != userId && !message.leido) {
                socket.emit('markMessageRead', { messageId: message.id })
              }
            }}
          >
            <div>{message.contenido}</div>
          </InView>
        ))}
        <div
          className={`text-[10px] flex items-center 
          ${messageSelf ? 'text-blue-100 justify-end' : 'text-gray-500'}`}
        >{formatTimeZone(dateGroup)}</div>
      </div>

      <div>
        {messageSelf
          ? readGroup
            ? <CheckCircleOutlined />
            : <CheckOutlined className="mr-1" />
          : null}
      </div>

    </div>
  )
}

export default ChatBubble